import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import Icon from "@ats/src/components/shared/Icon";
import Tooltip from "@ats/src/components/shared/Tooltip";
import breakpoint from "@shared/styles/breakpoints";

export interface ClearJobApplicationFiltersButtonProps {
  onClick: () => void;
}

const ClearJobApplicationFiltersButton: React.FunctionComponent<
  ClearJobApplicationFiltersButtonProps
> = ({ onClick }) => {
  return (
    <Tooltip label="Clear all filters">
      <Styled.Button type="button" onClick={onClick} aria-label="Clear filters">
        <Styled.Label>Clear filters</Styled.Label>
        <Styled.Icon>
          <Icon name="x" />
        </Styled.Icon>
      </Styled.Button>
    </Tooltip>
  );
};

export default ClearJobApplicationFiltersButton;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Button = styled.button((props: any) => {
  const t: any = props.theme;
  return css`
    label: ClearJobApplicationFiltersButton;
    ${[t.h(7), t.px(2), t.rounded.sm, t.text.xs]};
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border: none;
    background: none;
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    cursor: pointer;

    &:hover {
      color: ${t.dark ? t.color.gray[200] : t.color.black};
      text-decoration: underline;
    }

    &:focus {
      text-decoration: underline;
    }
  `;
});

Styled.Label = styled.span((props: any) => {
  const t: any = props.theme;
  return css`
    label: ClearJobApplicationFiltersButton_Label;
    display: inline;

    ${breakpoint.xl} {
      display: inline;
    }
  `;
});

Styled.Icon = styled.span((props: any) => {
  const t: any = props.theme;
  return css`
    label: ClearJobApplicationFiltersButton_Icon;
    ${t.text.sm};
    display: none;

    ${breakpoint.xl} {
      display: none;
    }
  `;
});
